import { NodeBehaviorHook } from '../../registry/types';

export const useCodeNodeBehavior: NodeBehaviorHook = (_data, _nodeState) => {
  return {};
};
